import { render, staticRenderFns } from "./StepperAddress.vue?vue&type=template&id=5d4902e8"
import script from "./StepperAddress.vue?vue&type=script&lang=js"
export * from "./StepperAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports